function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.205,
    viewBox: "0 0 17 20.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Delete icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 932",
    d: "M627.577 246.435h-3.5v-.946a2.842 2.842 0 0 0-2.838-2.838h-2.868a2.842 2.842 0 0 0-2.838 2.838v.946h-3.06a.946.946 0 1 0 0 1.892h15.108a.946.946 0 0 0 0-1.892zm-10.156 0v-.946a.948.948 0 0 1 .946-.946h2.868a.948.948 0 0 1 .946.946v.946z",
    transform: "translate(-611.523 -242.651)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 933",
    d: "M625.768 250.651a.946.946 0 0 0-.946.946v7.453a2.429 2.429 0 0 1-2.525 2.343h-4.425a2.4 2.4 0 0 1-2.495-2.313v-7.48a.946.946 0 1 0-1.892 0v7.515a4.315 4.315 0 0 0 4.285 4.176h4.498a4.338 4.338 0 0 0 4.445-4.2V251.6a.946.946 0 0 0-.945-.949z",
    transform: "translate(-611.629 -243.082)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 934",
    d: "M619.6 257.573V251.6a.946.946 0 1 0-1.892 0v5.976a.946.946 0 1 0 1.892 0z",
    transform: "translate(-611.857 -243.082)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 935",
    d: "M623.214 257.573V251.6a.946.946 0 1 0-1.892 0v5.976a.946.946 0 1 0 1.892 0z",
    transform: "translate(-612.051 -243.082)",
    style: {
      fill: "#175664"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/Delete icon.a3eb482b.svg";
export { ForwardRef as ReactComponent };